import { useEffect, useState } from 'react';

// Returns the state of a key every time it is pressed and released
// TODO: Capture and handle a held key

function useKeyPress(targetKey) {
  const [isPressed, setIsPressed] = useState(false);
  function downHandler(e) {
    if (e.keyCode === targetKey) {
      setIsPressed(true);
    }
  }

  const upHandler = (e) => {
    if (e.keyCode === targetKey) {
      setIsPressed(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return isPressed;
}

export default useKeyPress;
